import React, { useState } from 'react';

// Types
import { UpdateAiReportType } from 'Shared/types/UpdateAiReportType.type';

// Components
import WpTextField from 'Wpds/components/text-field/WpTextField';
import ReportPageSection from './ReportPageSection';

// Styles
import './UpdateAiReport.scss';

type Props = {
  report: UpdateAiReportType;
  isEditing: boolean;
  handleUpdate: Function;
};

const UpdateAiReport = ({ report, isEditing, handleUpdate }: Props) => {
  const [name, setName] = useState(report.name);

  const handleUpdateReportNameChange = (value: string) => {
    setName(value);
    handleUpdate({ name: value });
  };

  const reportBodies = report.body.sort((a, b) => {
    if (a.position < b.position) return -1;
    if (a.position > b.position) return 1;
    return 0;
  });

  const baseClassName = 'UpdateAiReport';
  return (
    <div className={baseClassName}>
      {isEditing ? (
        <div className={`${baseClassName}__title--edit`}>
          <WpTextField
            id="title"
            name="title"
            label="Report Title"
            placeholder="Report Title"
            value={name}
            labelHidden
            max={50}
            onChange={handleUpdateReportNameChange}
          />
        </div>
      ) : (
        <h3 className={`${baseClassName}__title`}>{name}</h3>
      )}

      <div className={`${baseClassName}__sections`}>
        {reportBodies.map(section => {
          return (
            <div className={`${baseClassName}__sections__section`} key={section.templateSectionSlug}>
              <ReportPageSection section={section} isEditing={isEditing} handleUpdate={handleUpdate} />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default UpdateAiReport;
